import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import TextMarquee from "@/components/TextMarquee";
import Inventory from "@/components/Inventory";
import Manifesto from "@/components/Manifesto";
import Testimonials from "@/components/Testimonials";
import ScheduleCall from "@/components/ScheduleCall";
import Footer from "@/components/Footer";
import BookingDialog from "@/components/BookingDialog";

export default function Home() {
  return (
    <div className="bg-cream">
      <Navbar />
      <Hero />
      <TextMarquee />
      <Inventory />
      <Manifesto />
      <Testimonials />
      <ScheduleCall />
      <Footer />
      <BookingDialog />
    </div>
  );
}
